<template>
  <footer class="pb-5 pt-sm-5 footer-bg" style="padding-top: 1px">
    <div class="container">
      <div
        class="home_mainContent"
        v-if="content"
        v-html="content.settings.site.first_home_content"
      ></div>
    </div>
    <section class="get-subscribe justify-content-md-between mt-5 container">
      <section v-if="content" class="text-right pl-3 w-100">
        <img
          style="width:120px;height:50px;"
          class="mb-2"
          width="120"
          :src="'https://api.paaakar.com/storage/' + content.settings.site.logo"
          alt=""
        />
      </section>
      <section
        class="w-100 d-flex align-items-center mb-sm-3 mt-sm-0 mt-3 mb-4"
      >
        <span class="newsletter-title">خبرنامه پاکار</span>
        <form id="sendEmailForm" class="w-100 d-flex justify-content-between">
          <span class="my-auto ml-2 mr-1">
            <svg
              width="19"
              height="19"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.2677 9.06113L13.0023 12.4954C12.1951 13.1283 11.0635 13.1283 10.2563 12.4954L5.95424 9.06113"
                stroke="#999"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.88787 3.5H16.3158C17.6752 3.51525 18.969 4.08993 19.896 5.0902C20.823 6.09048 21.3022 7.42903 21.222 8.79412V15.322C21.3022 16.6871 20.823 18.0256 19.896 19.0259C18.969 20.0262 17.6752 20.6009 16.3158 20.6161H6.88787C3.96796 20.6161 2 18.2407 2 15.322V8.79412C2 5.87545 3.96796 3.5 6.88787 3.5Z"
                stroke="#999"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>

          <input
            type="text"
            v-model="email"
            class="bg-none w-100 h-100 fontsize-mini newsletter-input"
            placeholder="آدرس ایمیل خود را وارد کنید..."
          />
          <button
            @click.prevent="sendEmail()"
            :class="{ disabled: loading || disabled }"
            class="
              fontsize-mini
              text-white
              py-1
              px-3
              align-self-end
              newsletter-btn
            "
          >
            عضویت
          </button>
        </form>
      </section>
    </section>
    <div class="main-footer container mb-md-0 mb-4">
      <div class="footer-call-location pl-3 text-right position-relative">
        <section>
          <p class="text-color-666" style="text-align: justify">
            {{ content.settings.site.footer_about }}
          </p>
        </section>
        <section class="mb-2 mt-2">
          <div>
            <svg
              class="d-inline-block"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.3558 2.00793C14.1328 1.97595 13.9087 2.04191 13.7304 2.18381C13.5472 2.32771 13.4326 2.53557 13.4077 2.76841C13.355 3.23908 13.6946 3.66479 14.1646 3.71776C17.4063 4.07951 19.9259 6.60477 20.2904 9.85654C20.3392 10.2922 20.7047 10.621 21.1409 10.621C21.1738 10.621 21.2057 10.619 21.2385 10.615C21.4666 10.59 21.6697 10.4771 21.8132 10.2972C21.9556 10.1174 22.0203 9.89351 21.9944 9.66467C21.5403 5.60746 18.4002 2.45862 14.3558 2.00793ZM14.4181 5.48994C13.942 5.402 13.5048 5.70579 13.4142 6.17047C13.3236 6.63515 13.6283 7.08884 14.0914 7.17978C15.4857 7.45159 16.5623 8.53085 16.8351 9.92989V9.93089C16.9128 10.3336 17.2674 10.6264 17.6757 10.6264C17.7305 10.6264 17.7852 10.6214 17.841 10.6114C18.3041 10.5185 18.6088 10.0658 18.5182 9.60012C18.1109 7.51055 16.5025 5.89666 14.4181 5.48994ZM16.0001 15.0905C16.4515 14.8302 16.9615 14.5362 17.6047 14.673C18.1873 14.7959 20.1731 16.4078 20.7169 16.9665C21.0734 17.3322 21.2716 17.7099 21.3025 18.0877C21.3562 19.5697 19.3425 21.2615 18.976 21.4724C18.489 21.8231 17.9224 22 17.286 22C16.6357 22 15.9106 21.8151 15.1199 21.4464C10.8296 19.6556 4.27553 13.231 2.54266 8.97395C1.82362 7.38903 1.81864 6.08193 2.53071 5.09961C2.81454 4.63892 4.43288 2.71325 5.88192 2.7742C6.26733 2.80718 6.64179 3.00505 7.00928 3.3648C7.56499 3.90942 9.13653 5.90106 9.25803 6.48565C9.39247 7.13521 9.09769 7.65185 8.83576 8.10554C8.7799 8.20307 8.70463 8.31881 8.62217 8.4456C8.3092 8.92683 7.89264 9.56735 8.04004 9.97626C9.09669 12.5705 11.5376 14.8339 14.133 15.8972C14.5343 16.0431 15.1745 15.6235 15.6542 15.3092C15.7791 15.2273 15.8932 15.1525 15.9893 15.0967L16.0001 15.0905Z"
                fill="#ffffaa"
              />
            </svg>
            <h6 class="weight-bold fontsize-small d-inline-block pr-1">
              شماره تماس و ایمیل:
            </h6>
            <div>
              <template v-if="!loading">
                <span
                  class="fontsize-mini text-color-444w d-md-inline-block d-sm-block"
                  >{{ content.settings.site.email }}</span
                ><span class="mx-2 d-md-inline-block d-sm-none">/</span>
                <span
                  class="fontsize-mini text-color-444w d-md-inline-block d-sm-block"
                  >{{ content.settings.site.mobile }}</span
                >
              </template>
              <template v-else>
                <span
                  ><b-skeleton width="105px" class="d-inline-block mr-2"
                /></span>
                <span
                  ><b-skeleton width="105px" class="d-inline-block mr-2"
                /></span>
              </template>
            </div>
          </div>
        </section>
        <section class="mb-2 mt-lg-0 mt-sm-2 mt-2 mr-lg-0 mr-sm-3">
          <h6 class="weight-bold fontsize-small d-inline-block pr-1">
            شماره تماس پشتیبانی:
          </h6>
          <div>
            <template v-if="!loading">
              <span
                class="fontsize-mini text-color-444w d-md-inline-block d-sm-block"
                >{{ content.settings.site.mobile_support }}</span
              >
            </template>
            <template v-else>
              <span
                ><b-skeleton width="105px" class="d-inline-block mr-2"
              /></span>
            </template>
          </div>
        </section>
        <section class="mt-lg-0 mt-sm-5 mt-2 mr-lg-0 mr-sm-3">
          <div>
            <svg
              class="d-inline-block"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.5 10.3178C3.5 5.71789 7.34388 2 11.9934 2C16.6561 2 20.5 5.71789 20.5 10.3178C20.5 12.6357 19.657 14.7876 18.2695 16.6116C16.7388 18.6235 14.8522 20.3765 12.7285 21.7524C12.2425 22.0704 11.8039 22.0944 11.2704 21.7524C9.13474 20.3765 7.24809 18.6235 5.7305 16.6116C4.34198 14.7876 3.5 12.6357 3.5 10.3178ZM9.19423 10.5768C9.19423 12.1177 10.4517 13.3297 11.9934 13.3297C13.5362 13.3297 14.8058 12.1177 14.8058 10.5768C14.8058 9.0478 13.5362 7.77683 11.9934 7.77683C10.4517 7.77683 9.19423 9.0478 9.19423 10.5768Z"
                fill="#ffffaa"
              />
            </svg>

            <h6 class="weight-bold fontsize-small d-inline-block pr-1 ">
              آدرس فروشگاه:
            </h6>
            <div>
              <address
                v-if="!loading"
                class="fontsize-mini text-color-444w text-justify"
              >
                {{ content.settings.site.address }}
              </address>
              <b-skeleton v-else width="270px" />
            </div>
          </div>
        </section>
      </div>

      <div>
        <div class="d-flex">
          <div style="flex-grow: 1">
            <section
              class="d-flex justify-content-between align-items-baseline mt-4"
            >
              <SocialNetworks />
            </section>
            <section
              class="
            quick-access
            d-lg-flex d-none
            justify-content-between
            align-items-baseline
            my-4
          "
            >
              <h6 class="text-color-444w fontsize-small font-weight-bold">
                دسترسی سریع:
              </h6>
              <nav class="ml-auto">
                <ul class="nav fontsize13">
                  <template v-if="!loading">
                    <li
                      v-for="item in content.menu.footer"
                      :key="item.id"
                      class="nav-item fontsize-mini mr-3"
                    >
                      <DynamicLinker :item="item">{{
                        item.title
                      }}</DynamicLinker>
                    </li>
                  </template>
                  <template v-else>
                    <li v-for="index in 5" :key="index" class="nav-item">
                      <a class="nav-link">
                        <b-skeleton width="40px" />
                      </a>
                    </li>
                  </template>
                </ul>
              </nav>
            </section>
          </div>
          <a
            referrerpolicy="origin"
            class="d-flex flex-column justify-content-center mr-3"
            target="_blank"
            href="https://trustseal.enamad.ir/?id=259264&amp;Code=FijbbPaxPtGTsKFJJawU"
            ><img
              referrerpolicy="origin"
              src="https://Trustseal.eNamad.ir/logo.aspx?id=259264&amp;Code=FijbbPaxPtGTsKFJJawU"
              alt=""
              style="cursor:pointer"
              id="FijbbPaxPtGTsKFJJawU"
          /></a>

          <!--          <a target="_blank" href="#" class="d-flex flex-column justify-content-center mr-3">-->
          <!--            <img width="90" :src="require('@/assets/images/other/enamad.png')" alt="اینماد">-->
          <!--          </a>-->
        </div>
        <hr />
        <section class="d-flex text-sm-right text-center mt-4 flex-column">
          <p>
            <svg
              class="d-sm-inline-block d-none ml-1"
              height="20"
              viewBox="0 0 512 512"
              width="20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill="#ffffaa"
                d="m178.925781 177.925781c-42.5 42.5-42.5 111.648438 0 154.148438s111.648438 42.5 154.148438 0c7.8125-7.8125 20.476562-7.8125 28.285156 0s7.808594 20.476562 0 28.285156c-29.046875 29.046875-67.203125 43.570313-105.359375 43.570313s-76.3125-14.523438-105.359375-43.570313c-58.09375-58.097656-58.09375-152.625 0-210.71875 58.097656-58.09375 152.625-58.09375 210.71875 0 7.8125 7.808594 7.8125 20.472656 0 28.285156-7.808594 7.808594-20.472656 7.808594-28.285156 0-42.5-42.5-111.648438-42.5-154.148438 0zm258.09375-102.945312c-48.351562-48.351563-112.640625-74.980469-181.019531-74.980469s-132.667969 26.628906-181.019531 74.980469c-48.351563 48.351562-74.980469 112.640625-74.980469 181.019531s26.628906 132.667969 74.980469 181.019531c48.351562 48.351563 112.640625 74.980469 181.019531 74.980469 46.8125 0 92.617188-12.757812 132.460938-36.894531 9.449218-5.722657 12.46875-18.019531 6.746093-27.46875-5.726562-9.449219-18.023437-12.46875-27.46875-6.742188-33.59375 20.347657-72.234375 31.105469-111.738281 31.105469-119.101562 0-216-96.898438-216-216s96.898438-216 216-216 216 96.898438 216 216c0 42.589844-12.664062 84.042969-36.625 119.882812-6.140625 9.183594-3.671875 21.605469 5.507812 27.742188 9.1875 6.140625 21.605469 3.671875 27.742188-5.507812 28.378906-42.441407 43.375-91.585938 43.375-142.117188 0-68.378906-26.628906-132.667969-74.980469-181.019531zm0 0"
              />
            </svg>
            تمامی حقوق این سایت مربوط به
            <span class="font-weight-bold">سایت پاکار</span> می باشد
          </p>
          <p class="mb-1">
            طراحی شده:
            <a
              style="color: var(--color-theme4)"
              target="_blank"
              href="https://shetabit.com/"
              >گروه شتاب</a
            >

            سئو شده:
            <a
              style="color: var(--color-theme4)"
              target="_blank"
              >متین خبیر</a
            >
          </p>
        </section>
      </div>
    </div>
  </footer>
</template>

<script>
import findUrl from "@/libraries/links/LinkResolver";
import DynamicLinker from "./DynamicLinker";
import { BSkeleton } from "bootstrap-vue";
import ZWhatsappSvg from "./ZWhatsappSvg";
import SocialNetworks from "./SocialNetworks";

export default {
  name: "Footer",
  components: { SocialNetworks, ZWhatsappSvg, DynamicLinker, BSkeleton },
  computed: {
    // دریافت محتوای درخواست هوم
    content() {
      return this.$store.getters["front/getHomeData"];
    },
    loading() {
      return this.$store.getters["front/getHomeDataStatus"];
    },
  },
  data() {
    return {
      email: null,
      disabled: false,
    };
  },
  methods: {
    findUrl,
    sendEmail() {
      if (!this.email) {
        return window.swal({
          title: "خطا!",
          text: "لطفا ایمیل خود را وارد کنید",
          icon: "warning",
          timer: 2000,
        });
      } else if (!this.validEmail(this.email)) {
        return window.swal({
          title: "خطا!",
          text: "لطفا فرمت ایمیل خود را به درستی وارد کنید",
          icon: "warning",
          timer: 2000,
        });
      }
      const fromData = new FormData();
      fromData.append("email", this.email);
      this.disabled = true;
      this.$axios.post("/front/newsletters", fromData).then((response) => {
        this.disabled = false;
        this.email = null;
        window.swal({
          title: "تبریک",
          text: "ایمیل شما برای عضویت در خبرنامه ما ثبت سیستم شد",
          icon: "success",
          timer: 2000,
        });
      });
    },
    validEmail: function(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
  },
};
</script>

<style scoped>
.imgSkeleton {
  height: 70px;
}

.errorEmail {
  border-bottom: 1px solid red;
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.enamad-container {
  position: absolute;
  left: 30px;
  top: 50%;
  transform: translateY(-50%);
}

.newsletter-btn {
  background: var(--color-theme);
}

.get-subscribe form {
  height: 40px;
  border: 2px solid var(--color-da);
  transition: 0.3s;
}

.get-subscribe form:focus-within {
  border: 2px solid var(--color-theme3);
}

/* .get-subscribe form input::placeholder{
    color: white;
} */

.get-subscribe form svg > path {
  transition: 0.3s;
}

.get-subscribe form button {
  height: 36px;
  transition: 0.3s;
  position: relative;
  bottom: 0px;
  left: -1px;
}

.get-subscribe form button:hover {
  box-shadow: 0 0 5px #ccc;
}

.newsletter-title {
  flex-shrink: 0;
  font-size: 19px;
  font-weight: bold;
  margin-left: 10px;
}

@media screen and (max-width: 587px) {
  .newsletter-title {
    font-size: 1rem;
  }
}

p {
  font-size: 14px;
}

.newsletter-input::placeholder {
  color: #c4c1c1;
}
.home_mainContent {
  margin: 15px auto;
  width: 95%;
  position: relative;
}
</style>
